/* eslint-disable no-template-curly-in-string */
import { ArrayLocale, BooleanLocale, DateLocale, MixedLocale, NumberLocale, ObjectLocale, StringLocale } from 'yup/lib/locale';
import printValue from 'yup/lib/util/printValue';
import { Message } from "yup/lib/types"

export const mixed: Required<MixedLocale> = {
  default: '${path} inválido',
  required: '${path} requerido',
  oneOf: '${path} debe ser uno de los siguientes valores: ${values}',
  notOneOf: '${path} no puede ser de uno de los siguientes valores: ${values}',
  notType: ({ path, type, value, originalValue }) => {
    const isCast = originalValue != null && originalValue !== value;
    let msg =
      `${path} debe ser de tipo \`${type}\`, ` +
      `pero el valor final: \`${printValue(value, true)}\`` +
      (isCast
        ? ` (cambiado de valor \`${printValue(originalValue, true)}\`).`
        : '.');

    if (value === null) {
      msg += `\n Si se pretende que "null" sea un valor vacío, asegúrese de marcar el esquema como \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} debe definir',
};

export const string: Required<StringLocale & { ascii?: Message, emailOrPhone?: Message, zxcvbn?: Message }> = {
  length: '${path} debe ser preciso ${length} personaje',
  min: '${path} mínimo ${min} personaje',
  max: '${path} máximo ${max} personaje',
  matches: '${path} debe estar de acuerdo con regex: "${regex}"',
  email: '${path} debe ser un correo electrónico válido',
  url: '${path} debe ser una URL válida',
  uuid: '${path} debe ser un UUID válido',
  trim: '${path} debe ser un caracter sin espacio al final',
  lowercase: '${path} debe estar en minúsculas',
  uppercase: '${path} debe estar en mayúsculas',

  ascii: '${path} contiene un carácter no válido',
  emailOrPhone: '${path} debe ser datos válidos',

  zxcvbn: '${path} no es lo suficientemente fuerte.',
};

export const number: Required<NumberLocale> = {
  min: '${path} debe ser mayor o igual que ${min}',
  max: '${path} debe ser menor o igual que ${max}',
  lessThan: '${path} debe ser menor que ${less}',
  moreThan: '${path} debe ser más que ${more}',
  positive: '${path} Debe ser un número positivo',
  negative: '${path} debe ser un numero negativo',
  integer: '${path} debe ser entero'
};

export const date: Required<DateLocale> = {
  min: '${path} debe después ${min}',
  max: '${path} debe antes ${max}',
};

export const boolean: BooleanLocale = {
  isValue: '${path} debe ${value}',
};

export const object: Required<ObjectLocale> = {
  noUnknown: '${path} tiene una clave no especificada: ${unknown}'
};

export const array: Required<ArrayLocale & { unique?: Message }> = {
  min: '${path} debe tener como minimo ${min} elementos',
  max: '${path} debe ser menor o igual que ${max} elementos',
  length: '${path} debe tener ${length} elementos',

  unique: '${path} ya existe'
};

export default Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
});
